<div class="login-container">
  <div class="login-button"><button type="button" class="btn btn-secondary5 btn-lg" (click)="login()">Log In</button></div>
  <div class="login-image"><img src="assets/images/logos/logo_white.png" alt="The ISG logo in white" /></div>
  <div class="login-text">{{appname}}</div>
  <div class="login-version-text">{{buildversion}}</div>
</div>
